// extracted by mini-css-extract-plugin
export default {"table":"styles_table__bf5EB","label":"styles_label__e0FUe","green":"styles_green__woP+o","purple":"styles_purple__bxWjR"};